// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"1feeb9df","977":"74931a18"}[chunkId] + ".chunk.js";
};